import React, { useState, useEffect } from 'react';
import api from 'services/api';
import { useMyContext, useAssets } from 'hooks'
import { Wrapper, NavBox, NavMiddle, NavLeft, NavItem, StyledText, StyledCurrencyInput } from './styles'
import { Spinner, Period, InitialApplication } from 'components'


const ThirdHeader = ({selectedPeriodIndex, setSelectedPeriodIndex, setSelectedPeriod, selectedPeriod, initialApplication, setInitialApplication, selectedTab}) => {
  const { benchmarkAssets, selectedBenchmarksIndexes, addAsset, removeAsset } = useAssets();
  const [ periods, setPeriods ] = useState([]);
  const [ value, setValue ] = useState(initialApplication);
  const MIN_APPLICATION = 1;
  const MAX_APPLICATION = 1000000000;
  const { t } = useMyContext();
  const { innerWidth } = window;

  const fetchPeriods = async () => {
    const periods = await api.get('period');
    setPeriods(periods.data);
  }

  const handleBenchmarkClick = async (e) => {
    const index = Number(e.currentTarget.dataset.index);

    if(selectedBenchmarksIndexes.length === 1 && selectedBenchmarksIndexes.includes(index)) return;
    
    if(selectedBenchmarksIndexes.includes(index)){
      removeAsset(benchmarkAssets[index].identifier, benchmarkAssets[index].assetType);
    }else{
      await addAsset(benchmarkAssets[index], selectedPeriod, initialApplication);
    }
  }

  const handlePeriodClick = (e) => {
    const index = e.currentTarget.dataset.index;

    setSelectedPeriodIndex(Number(index));
    setSelectedPeriod(periods[index])  
  }

  const handleBlur = () => {
    if(initialApplication !== value){
      if(value < MIN_APPLICATION){
        setValue(MIN_APPLICATION)
        setInitialApplication(MIN_APPLICATION)
      }else if(value > MAX_APPLICATION){
        setValue(MAX_APPLICATION)
        setInitialApplication(MAX_APPLICATION)
      }else{
        setInitialApplication(value)
      }
    }
  }

  const handleChange = (event, _, floatvalue) => {
    event.preventDefault();
    if(floatvalue > MAX_APPLICATION){
      setValue(MAX_APPLICATION);  
    }else{
      setValue(floatvalue);
    }
  }

  const handleKeyPress = (event) => {
    if(event.code === "Enter"){
      handleBlur();
      event.target.blur();
    } 
  }

  const benchMarkIsSelected = (index) => {
    return selectedBenchmarksIndexes.length !== 0 && selectedBenchmarksIndexes.includes(index)
  }

  useEffect(async() => {
    await fetchPeriods();
  }, []);

  return (
    <Wrapper>
      <NavBox>
        <StyledText bold>{t['molecules:ThirdHeader:benchmark']}</StyledText>
        <NavLeft style={{border: 'none'}}>
          {benchmarkAssets && benchmarkAssets.map((benchMark, index) => (
            <NavItem 
              key={index} 
              hasBorder 
              index={index} 
              isSelected={benchMarkIsSelected(index)} 
              onClick={handleBenchmarkClick}
            >
              {benchMark.label}
            </NavItem>
          ))}
        </NavLeft>
      </NavBox>
      {innerWidth > 920 ?
        <NavBox>
          <StyledText bold>{t['molecules:ThirdHeader:periodo']}</StyledText>
          <NavMiddle style={{border: 'none'}}>
            {periods && periods.map((period, index) => (
                <NavItem hasBorder index={index} isSelected={selectedPeriodIndex === index} onClick={handlePeriodClick}>{
                  t[`period:${period}`]
                }</NavItem>
              ))
            }
          </NavMiddle>
        </NavBox>
        :
        <Period selectedPeriod={selectedPeriod} periods={periods} setSelectedPeriod={setSelectedPeriod} selectedTab={selectedTab}  />
      }
      {selectedTab === 0 ? (innerWidth > 920 ?
        <NavBox>
          <StyledText bold>
            {t['molecules:ThirdHeader:aplicaoInicial']}
          </StyledText>
          <NavMiddle style={{border: 'none'}}>
            <StyledCurrencyInput
              value={value} 
              decimalSeparator=","
              thousandSeparator="."
              prefix="R$"
              allowNegative={false}
              onKeyPress={handleKeyPress}
              onBlur={handleBlur}
              maxLength={17}
              onChangeEvent={handleChange}/>
          </NavMiddle>
        </NavBox>
        :
        <InitialApplication initialApplication={initialApplication} setInitialApplication={setInitialApplication} />
        )
        :
        <div style={{width: '189px'}}></div>
      }
    </Wrapper>
  );
}

export default ThirdHeader;